import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router-dom';
import { Card } from '@/components/primitives/Card';
import { Spinner } from '@/components/primitives/Spinner';
import { useOgAuth } from '@/api/opengater/OgAuthContext';
import { useCurrentUser } from './CurrentUserContext';
import { defaultPathForRole, roleCan } from './roles';
function Gate({ role, status, allow, }) {
    if (status === 'loading' || status === 'idle') {
        return (_jsx(Card, { children: _jsxs("div", { style: { padding: 18, display: 'flex', alignItems: 'center', gap: 10 }, children: [_jsx(Spinner, { size: 16 }), " \u041F\u0440\u043E\u0432\u0435\u0440\u044F\u0435\u043C \u043F\u0440\u0430\u0432\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430\u2026"] }) }));
    }
    if (roleCan(role, allow))
        return _jsx(Outlet, {});
    const destination = defaultPathForRole(role);
    if (destination)
        return _jsx(Navigate, { to: destination, replace: true });
    return (_jsx(Card, { children: _jsxs("div", { style: { padding: 18 }, children: [_jsx("strong", { children: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u043F\u0440\u0430\u0432" }), _jsx("div", { style: { marginTop: 6, color: 'var(--text-secondary)' }, children: "\u0414\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u043D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u0432 \u0430\u0434\u043C\u0438\u043D-\u043F\u0430\u043D\u0435\u043B\u0438." })] }) }));
}
export function PanelRoleRoute({ allow }) {
    const { role, status } = useCurrentUser();
    return _jsx(Gate, { role: role, status: status, allow: allow });
}
export function OgRoleRoute({ allow }) {
    const { role, roleStatus } = useOgAuth();
    return _jsx(Gate, { role: role, status: roleStatus, allow: allow });
}
export function RoleHomeRedirect({ source }) {
    const panel = useCurrentUser();
    const opengater = useOgAuth();
    const role = source === 'panel' ? panel.role : opengater.role;
    const status = source === 'panel' ? panel.status : opengater.roleStatus;
    if (status === 'loading' || status === 'idle') {
        return (_jsx(Card, { children: _jsxs("div", { style: { padding: 18, display: 'flex', alignItems: 'center', gap: 10 }, children: [_jsx(Spinner, { size: 16 }), " \u041E\u0442\u043A\u0440\u044B\u0432\u0430\u0435\u043C \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0439 \u0440\u0430\u0437\u0434\u0435\u043B\u2026"] }) }));
    }
    const destination = defaultPathForRole(role);
    if (destination)
        return _jsx(Navigate, { to: destination, replace: true });
    return (_jsx(Card, { children: _jsx("div", { style: { padding: 18 }, children: _jsx("strong", { children: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u043F\u0440\u0430\u0432" }) }) }));
}
